/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const ClassifyGroupBy = {
  UserId: "user_id",
  ApiKeyId: "api_key_id",
  Model: "model",
} as const;
export type ClassifyGroupBy = ClosedEnum<typeof ClassifyGroupBy>;

/** @internal */
export const ClassifyGroupBy$inboundSchema: z.ZodNativeEnum<
  typeof ClassifyGroupBy
> = z.nativeEnum(ClassifyGroupBy);
/** @internal */
export const ClassifyGroupBy$outboundSchema: z.ZodNativeEnum<
  typeof ClassifyGroupBy
> = ClassifyGroupBy$inboundSchema;
